import React from 'react';

export default function FormInput({
    isHtmlLabel = false,
    hideLabel = false,
    label,
    showError = false,
    errorText = '',
    horizontalLayout = false,
    parentGridClass = 'tw-grid-cols-3',
    labelGridClass = 'tw-col-span-1',
    inputGridClass = 'tw-col-span-2',
    labelClassName = '',
    inputClassName = '',
    ...props
}) {
    return horizontalLayout ? (
        <div className={parentGridClass + ' tw-grid tw-gap-4'}>
            <div className={labelGridClass}>
                {!hideLabel &&
                    (isHtmlLabel ? (
                        <label htmlFor={props.name} className={`text-input__label ${labelClassName}`} dangerouslySetInnerHTML={{ __html: label }}></label>
                    ) : (
                        <label htmlFor={props.name} className={`text-input__label ${labelClassName}`}>
                            {label} {props.required && '*'}
                        </label>
                    ))}
            </div>
            <div className={inputGridClass + ' tw-flex tw-flex-col tw-space-y-1.5'}>
                <input className={`${showError ? 'tw-border tw-border-red-500 text-input' : 'tw-border-0 text-input'} ${inputClassName}`} {...props} />
                {showError ? <div className="tw-text-red-500 tw-text-sm">{errorText}</div> : null}
            </div>
        </div>
    ) : (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            {!hideLabel &&
                (isHtmlLabel ? (
                    <label htmlFor={props.name} className={`text-input__label ${labelClassName}`} dangerouslySetInnerHTML={{ __html: label }}></label>
                ) : (
                    <label htmlFor={props.name} className={`text-input__label ${labelClassName}`}>
                        {label} {props.required && '*'}
                    </label>
                ))}
            <input className={`${showError ? 'tw-border tw-border-red-500 text-input' : 'tw-border-0 text-input'} ${inputClassName}`} {...props} />
            {showError ? <div className="tw-text-red-500 tw-text-sm">{errorText}</div> : null}
        </div>
    );
}
